module.exports = __webpack_public_path__ + "static/media/CreateNewCard2.c3641b9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/CreateNewCard2.png
// module id = 262
// module chunks = 0